import PurpleWarning from '@/common/assets/icons/purpleWarningIcon.svg?react';
import { Box, Center } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import Button from '@/common/components/base/button/Button.tsx';
import MainModal from '@/common/components/base/modal/Modal.tsx';
import { MainModalProps } from '@/common/components/base/modal/Modal.type.ts';

export default ({ open, closeModal }: MainModalProps) => (
  <MainModal closeModal={closeModal} open={open}>
    <RegisteredPendingModal closeModal={closeModal} />
  </MainModal>
);

const RegisteredPendingModal = ({
  closeModal,
}: {
  closeModal: MainModalProps['closeModal'];
}) => {
  return (
    <Box>
      <Center mb="20px">
        <PurpleWarning />
      </Center>
      <Typography mb="20px">
        شما قبلا تقاضای همکاری خود را ثبت کرده‌اید و درخواست شما در درست بررسی
        می‌باشد.
      </Typography>
      <Button mb="20px" onClick={() => closeModal()} fullWidth>
        بازگشت
      </Button>
    </Box>
  );
};
